// extracted by mini-css-extract-plugin
module.exports = {"socialButtons":"socialButtons__PYJtg"};